module.exports = {"141123100":"蔚汾镇","141123101":"魏家滩镇","141123102":"瓦塘镇","141123103":"康宁镇","141123104":"高家村镇","141123105":"罗峪口镇","141123106":"蔡家会镇","141123200":"交楼申乡","141123201":"恶虎滩乡","141123202":"东会乡","141123203":"固贤乡","141123204":"奥家湾乡","141123205":"蔡家崖乡","141123206":"贺家会乡","141123207":"孟家坪乡","141123208":"赵家坪乡","141123209":"圪垯上乡","141123400":"兴县资源环保循环经济综合开发示范基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141123.json
// module id = 339
// module chunks = 0